import React, { useEffect } from "react";
import Banner from "../components/about/Banner";
import Structure from "../components/about/Structure";
import Experience from "../components/about/Experience";
import Platform from "../components/about/Platform";
import Trust from "../components/about/Trust";
import FAQ from "../components/about/FAQ";
import CTA from "../components/about/CTA";

function About() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="overflow-hidden pb-[80px] xl:pb-0">
      <Banner />
      <Structure />
      <Experience />
      <Platform />
      <Trust />
      <FAQ />
      <CTA />
    </div>
  );
}

export default About;
